// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getHasImageToShow } from './imageElementUtils';

export default (DecoratedComponent) => {
    class ImagePlaceholderDragAndDropDecorator extends React.Component {
        render() {
            const hasImageToShow = getHasImageToShow(this.props);

            // If not showing the placeholder, then just pass through all props
            // Otherwise force the allowDrop
            const renderProps = hasImageToShow ? null : { allowDrop: true };

            return <DecoratedComponent {...this.props} {...renderProps} />;
        }
    }

    ImagePlaceholderDragAndDropDecorator.propTypes = {
        element: PropTypes.object,
        attachment: PropTypes.object,
    };

    return ImagePlaceholderDragAndDropDecorator;
};
